export default {
  androidBase: {
    'note':	' Attentions',
    'equipmentcheck':	' Please notice that your device has been calibrated.',
    'confirminstrument':	' Please confirm the instrument calibration is completed.',
    'personaldocumen':	' Please confirm that you have entered the correct profile.',
    'datasetting':	' Please confirm to enter the normal data setting.',
    'explaincheck':	' Please follow the calibration instructions on the calibration page.',
    'notchargeuse':	' Don’t use when charging.',
    'weeklyprofile':	' Please calibrate device and update your profile once every week at least. ',
    'nextstep':	' Next Step ',
    'morningfasting':	' Morning Fasting ',
    'aftermeal':	'2 Hours After Meal ',
    'measure':	' Measure ',
    'startingup':	' Starting Up ',
    'startingoperation':	' Please long press the device’s power button for 2 seconds and the right side’s blue light is turned on.',
    'bluetoothconnection':	' Bluetooth Connecting…',
    'bluetootherro':	' Bluetooth connection failed. Please reconnect.',
    'maniphalanxawait':	' Please wait for the prompt to insert your finger.',
    'ambienttemperature':	' Recommended Ambient Temperature:27℃ -30℃',
    'fingertemperature':	' Recommended Finger Temperature:29℃ -35℃',
    'implementorfinger':	' Please put your finger into the device.',
    'insurvey':	'In Measure',
    'remainingtime':	'Time Remaining',
    'second':	'second',
    'staycoolgesture':	' Please keep calm and keep your current position.',
    'measuresugar':	' Blood Glucose Measurement ',
    'bosaturation':	'Blood Oxygen',
    'batterylevel':	'Battery Level',
    'temperature':	'Temperature',
    'humidity':	'Humidity',
    'fingertip':	'Fingertip',
    'ambient':	'Ambient',
    'rehydrate':	' Rehydrate',
    'enoughsleep':	'Keep enough sleep',
    'carbohydrate':	' Health Diet, According to the following order and amount, 2 high fiber vegetables, 2 protein, 1 carbohydrate ',
    'uncage':	' Engage in stress-relieving activities to relax.',
    'motioneverday':	' Exercise 30 minutes a day ',
    'periodicalexamination':	' Regular Health Examination',
    'testagain':	'Error, Please measure again.',
    'fingernotin':	'No finger inside!',
    'fingerremoved':	'Finger Removed!',
    'datacollection':	' Finger sensing error may result in incorrect data collection.',
    'notinsertedcorrectly':	'Data collection error! Please reinsert your finger. ',
    'fingernotinerro':	' Finger is not placed correctly!',
    'fingerstoohot':	' The finger temperature is too high, which may affect the measure results.',
    'fingertemperaturebase':	' The finger temperature is too low, which may affect the measure results.',
    'ambientnotinerro':	' The ambient temperature is too high, which may affect the measure results.',
    'environmentdry':	' The ambient is too dry, which may affect the measure results.',
    'ambienttemperaturebase':	' The finger temperature is too low, which may affect the measure results.',
    'lowdevicepower':	'Low battery! Please charging before measure. ',
    'ambientcondition':	' Meet Environmental Conditions ',
    'connectionfailed':	' Device connection failed, Please make sure the power is turned on. ',
    'fingersensor':	'Please put your finger into the sensor. '
  }
}
